/**
 * Does a saved card reference name this board widget? A card added this
 * session is keyed by a throwaway client id until its first save hands it a
 * real one, so a reference can hold either — match both rather than letting a
 * pick made before the first save go "gone" the moment the board reloads.
 */
export const matchesWidgetRef = (w, ref) => !!ref && !!w && (String(w.id) === ref || (w._id != null && String(w._id) === ref));

/** The id a picker should store for a board widget: its real one once it has one. */
export const widgetRefOf = (w) => String(w._id || w.id);

/** Settings keys that hold a reference to a sibling card on the same board. */
export const WIDGET_REF_KEYS = ["laborWidgetId", "profitWidgetId"];
